module.exports = __webpack_public_path__ + "img/bekijk-werk.b5e4f0b2.png";